import { Body } from '@vds/typography';
import React from 'react';
import './resourceTag.scss';

const ResourceTag = ({ text, backgroundColor= "#FFFFFF", isInPersonEvent }) => {

  return (
    <div>
    {isInPersonEvent ? (<div className='resourse-tag' style={{backgroundColor: backgroundColor}}>
      <Body size="small" bold>
        {text}
      </Body>
    </div>):<div className='resourse-tag' style={{backgroundColor: backgroundColor}}>
      <Body size="small" bold>
        {text}
      </Body>
    </div>}
    </div>
  );
};
export default ResourceTag;